import { adminClient } from "./admin";
import axios from "axios";

const API_ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;
const publicClient = axios.create({ baseURL: API_ROOT });

/* ========== Admin (owner-only) ========== */

/* Employees */
export const listEmployees = async (params = {}) =>
  (await adminClient().get("/admin/store-employees", { params })).data;
export const createEmployee = async (payload) =>
  (await adminClient().post("/admin/store-employees", payload)).data;
export const updateEmployee = async (id, patch) =>
  (await adminClient().patch(`/admin/store-employees/${id}`, patch)).data;
export const deleteEmployee = async (id) =>
  (await adminClient().delete(`/admin/store-employees/${id}`)).data;

/* Shifts */
export const listShifts = async (params = {}) =>
  (await adminClient().get("/admin/shifts", { params })).data;
export const shiftSummary = async (params = {}) =>
  (await adminClient().get("/admin/shifts/summary", { params })).data;
export const createShift = async (payload) =>
  (await adminClient().post("/admin/shifts", payload)).data;
export const updateShift = async (id, patch) =>
  (await adminClient().patch(`/admin/shifts/${id}`, patch)).data;
export const deleteShift = async (id) =>
  (await adminClient().delete(`/admin/shifts/${id}`)).data;

/* Task templates */
export const listTaskTemplates = async (params = {}) =>
  (await adminClient().get("/admin/task-templates", { params })).data;
export const createTaskTemplate = async (payload) =>
  (await adminClient().post("/admin/task-templates", payload)).data;
export const updateTaskTemplate = async (id, patch) =>
  (await adminClient().patch(`/admin/task-templates/${id}`, patch)).data;
export const deleteTaskTemplate = async (id) =>
  (await adminClient().delete(`/admin/task-templates/${id}`)).data;

/* Time entries (read-only) */
export const listTimeEntries = async (params = {}) =>
  (await adminClient().get("/admin/time-entries", { params })).data;

/* ========== Kiosk (public) ========== */
export const kioskStoreInfo = async (storeId) =>
  (await publicClient.get(`/kiosk/store/${storeId}`)).data;
export const kioskState = async (payload) =>
  (await publicClient.post("/kiosk/state", payload)).data;
export const kioskClockIn = async (payload) =>
  (await publicClient.post("/kiosk/clock-in", payload)).data;
export const kioskClockOut = async (payload) =>
  (await publicClient.post("/kiosk/clock-out", payload)).data;
export const kioskStartBreak = async (payload) =>
  (await publicClient.post("/kiosk/start-break", payload)).data;
export const kioskEndBreak = async (payload) =>
  (await publicClient.post("/kiosk/end-break", payload)).data;
export const kioskMyHours = async (payload) =>
  (await publicClient.post("/kiosk/my-hours", payload)).data;

export const CADENCE_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "adhoc", label: "One-off" },
];

export const WEEKDAY_OPTIONS = [
  { value: 0, label: "Monday" },
  { value: 1, label: "Tuesday" },
  { value: 2, label: "Wednesday" },
  { value: 3, label: "Thursday" },
  { value: 4, label: "Friday" },
  { value: 5, label: "Saturday" },
  { value: 6, label: "Sunday" },
];

export const listShiftTemplates = async () =>
  (await adminClient().get("/admin/shift-templates")).data;
export const createShiftTemplate = async (payload) =>
  (await adminClient().post("/admin/shift-templates", payload)).data;
export const updateShiftTemplate = async (id, payload) =>
  (await adminClient().put(`/admin/shift-templates/${id}`, payload)).data;
export const deleteShiftTemplate = async (id) =>
  (await adminClient().delete(`/admin/shift-templates/${id}`)).data;
export const copyPreviousWeek = async (payload) =>
  (await adminClient().post("/admin/shifts/copy-week", payload)).data;
